
import BalloonEditor from '@ckeditor/ckeditor5-editor-balloon/src/ballooneditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline'
import StrikethroughPlugin from '@ckeditor/ckeditor5-basic-styles/src/strikethrough'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import ListPlugin from '@ckeditor/ckeditor5-list/src/list'
import AutoformatPlugin from '@ckeditor/ckeditor5-autoformat/src/autoformat'
// import ContextedLinkPlugin from '@/components/Note/ContextedLinkPlugin'
import ContextedLinkPluginv2 from '@/components/Note/ContextedLinkPluginv2'
import ClickObserver from '@ckeditor/ckeditor5-engine/src/view/observer/clickobserver'

export default {
  name: 'ckeditor',

  render(createElement) {
    return createElement(this.tagName)
  },

  props: {
    // editor: {
    //   type: Function,
    //   default: null
    // },
    value: {
      type: String,
      default: ''
    },
    // config: {
    //   type: Object,
    //   default: () => ({})
    // },
    tagName: {
      type: String,
      default: 'div'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // Don't define it in #props because it produces a warning.
      // https://vuejs.org/v2/guide/components-props.html#One-Way-Data-Flow
      instance: null,
      editor: BalloonEditor,
      config: {
        placeholder: 'Click here to start typing...',
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          UnderlinePlugin,
          StrikethroughPlugin,
          LinkPlugin,
          HeadingPlugin,
          ParagraphPlugin,
          ListPlugin,
          AutoformatPlugin,
          // ContextedLinkPlugin,
          ContextedLinkPluginv2
        ],
        toolbar: {
          items: [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'link',
            'undo',
            'redo',
            'heading',
            'bulletedList',
            'numberedList'
          ]
        }
      }
    }
  },

  async mounted() {
    try {
      // performance.mark('mount ckeditor')
      const editor = await this.editor.create(this.$el, { ...this.config, initialData: this.value })
      // performance.mark('editor created')
      this.instance = editor
      editor.isReadOnly = this.disabled
      this.$_setUpEditorEvents()
      this.$emit('ready', editor)
    } catch (error) {
      console.error(error)
    }
  },

  beforeDestroy() {
    if (this.instance) {
      this.instance.destroy()
      this.instance = null
    }
    // Note: By the time the editor is destroyed (promise resolved, editor#destroy fired)
    // the Vue component will not be able to emit any longer. So emitting #destroy a bit earlier.
    this.$emit('destroy', this.instance)
  },

  watch: {
    // Synchronize changes of #value.
    value(val) {
      // If the change is the result of typing, the #value is the same as instance.getData().
      // In that case, the change has been triggered by instance.model.document#change:data
      // so #value and instance.getData() are already in sync. Executing instance#setData()
      // would demolish the selection.
      if (this.instance && this.instance.getData() !== val) {
        this.instance.setData(val)
      }
    },

    // Synchronize changes of #disabled.
    disabled(val) {
      this.instance.isReadOnly = val
    }
  },

  methods: {
    $_setUpEditorEvents() {
      const editor = this.instance
      editor.editing.view.addObserver(ClickObserver)
      editor.model.document.on('change:data', evt => {
        // const data = editor.getData()
        this.$emit('input')
      })
      editor.editing.view.document.on('focus', evt => {
        this.$emit('focus', evt, editor)
      })
      editor.editing.view.document.on('blur', evt => {
        this.$emit('blur', evt, editor)
      })
      editor.editing.view.document.on('click', (event, data) => {
        this.$emit('click', { event, data })
      })
      editor.editing.view.document.on('enter', (event, data) => {
        this.$emit('enter', { event, data })
      })
      editor.model.document.on('contextedLinkAutocompleteUpdate', (eventInfo, eventData) => {
        this.$emit('contextedLinkAutocompleteUpdate', eventData)
      })
      editor.model.document.on('contextedLinkAutocompleteKeypress', (eventInfo, eventData) => {
        this.$emit('contextedLinkAutocompleteKeypress', eventData)
      })
      editor.model.document.on('createNote', (eventInfo, eventData) => {
        this.$emit('createNote', eventData)
      })
    }
  }
}
